import type { ID } from '@octopus-do/octopus-project-core'
import { CommentsActions } from '@store/reducers/comments'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { useBooleanState } from '@/hooks'
import type { Comment, Recipient } from '@/types'
import { CommentActions } from '../CommentActions'
import { ThreadComment } from '../ThreadComment'
import css from './styles.module.css'

interface Props {
  users: Record<ID, Recipient>
  comment: Comment
}

export const ReplyComment: React.FC<Props> = ({ users, comment }) => {
  const dispatch = useDispatch()
  const { value: readOnly, toggle, setTrue } = useBooleanState(true)
  const { id, content, createdAt, updatedAt, owner } = comment
  const author = users[owner]

  const onSubmit = (value: string) => {
    setTrue()
    if (value === content) {
      return
    }
    dispatch(CommentsActions.update({ id, content: value }))
  }

  return (
    <ThreadComment
      onSubmit={onSubmit}
      content={content}
      createdAt={createdAt}
      updatedAt={updatedAt}
      author={author}
      storedName={comment.author}
      onCancel={setTrue}
      readOnly={readOnly}
      className={css.reply_comment}
    >
      <CommentActions
        className={css.reply_action}
        id={id}
        author={author?.id}
        setEdit={toggle}
      />
    </ThreadComment>
  )
}
